import Axios from 'axios';

import axios from './axios';

const parseUploadResponse = (data) => {
    const source = Array.isArray(data)
        ? data[0]
        : (data?.document ?? data?.documents?.[0] ?? data ?? {});

    return {
        id: source.id ?? source.Id,
        locator: source.locator ?? source.Locator,
    };
};

export const getFormRecordId = (form) => form?.id ?? form?.Id ?? null;

export const getForm = (id) => axios.get(`/forms/v1/${id}`);

export const getForms = (accountId, page) => {
    return axios.get(`/accounts/v1/${accountId}/forms?page=${page}`).then(({ data }) => {
        Array.isArray(data) &&
            data.map((el) => {
                try {
                    el.list = JSON.parse(el.list);
                    el.detail = JSON.parse(el.detail);
                } catch (error) {
                    console.warn(error);
                }
                return el;
            });
        return data;
    });
};

export const deleteForm = (id) => axios.delete(`/forms/v1/${id}`);

export const getImages = (id) => axios.get(`/forms/v1/${id}/documents`);

export const getUploadImageUrl = (id, data) => axios.post(`/forms/v1/${id}/documents`, data);

export const requestFormImageUpload = async (formId, fileName) => {
    const { data } = await axios.post('documents/v1', {
        folderId: '-1',
        entity: 'forms',
        entityId: String(formId),
        name: fileName,
        isCarrousel: true,
    });
    const { id, locator } = parseUploadResponse(data);

    if (!id || !locator) {
        throw new Error(`Invalid upload response: ${JSON.stringify(data)}`);
    }

    return { id, locator };
};

/** PUT to presigned storage URL — raw Axios, no API auth (see web4 FilesService). */
export const uploadImage = (url, file) =>
    Axios.put(url, file, {
        timeout: 0,
        maxContentLength: 128 * 1024 * 1024,
    });

export const deleteImage = (id) => axios.delete(`/documents/v1/${id}`);

// Templates

export const getFormTemplates = () => axios.get('/forms/v1/templates');

export const getFormTemplate = (id) => axios.get(`/forms/v1/${id}/templates`);

export const createFormTemplate = (data) => axios.post('/forms/v1/templates', data);

export const updateFormTemplate = (id, data) => axios.put(`/forms/v1/${id}/templates`, data);

export const deleteFormTemplate = (id) => axios.delete(`/forms/v1/${id}/templates`);
